//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    productRange: {
      type: Object,
      required: true
    },
    productCategories: {
      type: Array,
      required: true
    }
  }
}

